import { SectionItemListTypeEnum } from './sections';
import { TutorialExtraCategoryIdEnum } from './tutorials';

export enum ItemTypeEnum {
  Tutorial = 'tutorial',
  Course = 'course',
}

export const ITEM_EXTRA_CATEGORY_ID_BY_LIST_TYPE: Record<
  SectionItemListTypeEnum,
  TutorialExtraCategoryIdEnum
> = {
  [SectionItemListTypeEnum.Latest]:
    TutorialExtraCategoryIdEnum.Latest,
  [SectionItemListTypeEnum.Recommended]:
    TutorialExtraCategoryIdEnum.Recommended,
  [SectionItemListTypeEnum.Popular]:
    TutorialExtraCategoryIdEnum.Popular,
  [SectionItemListTypeEnum.Tag]: TutorialExtraCategoryIdEnum.All,
  [SectionItemListTypeEnum.Saved]: TutorialExtraCategoryIdEnum.Saved,
  [SectionItemListTypeEnum.History]:
    TutorialExtraCategoryIdEnum.History,
  [SectionItemListTypeEnum.Section]: TutorialExtraCategoryIdEnum.All,
  [SectionItemListTypeEnum.Courses]: TutorialExtraCategoryIdEnum.All,
};
